module.exports = __webpack_public_path__ + "static/img/gga.bd76ee0a.jpg";